import { PLATFORM } from 'aurelia-pal';

class AppUtils {
  attachWindowEvents(events, fn, ...rest) {
    const list = Array.isArray(events) ? events : [events];
    list.forEach((event) => PLATFORM.global.addEventListener(...[event, fn, ...rest]));
    return {
      dispose: () => this.detachWindowEvents(list, fn, ...rest),
    };
  }
  detachWindowEvents(events, fn, ...rest) {
    const list = Array.isArray(events) ? events : [events];
    list.forEach((event) => PLATFORM.global.removeEventListener(...[event, fn, ...rest]));
  }
  sortObjectsList(property, order = 'asc') {
    const orderN = order === 'asc' ? 1 : -1;
    return (a, b) => {
      const propA = a[property];
      const propB = b[property];
      let result = 0;
      if (propA > propB) {
        result = 1 * orderN;
      } else if (propB > propA) {
        result = -1 * orderN;
      }

      return result;
    };
  }
  scrollToTop() {
    PLATFORM.global.scrollTo(0, 0);
  }
  /**
   * Returns the value of an object property using a path.
   * @example
   * const obj = {
   *   propOne: {
   *     propOneSub: 'Charito!',
   *   },
   *   propTwo: '!!!',
   * };
   * console.log(Utils.getPropertyWithPath(
   *   obj,
   *   'propOne/propOneSub'
   * ));
   * // Will output `Charito!`
   *
   * @param {Object} obj                 The object from where the property will be read.
   * @param {string} objPath             The path to the property.
   * @param {string} [pathDelimiter='/'] The delimiter that will separate the path components.
   * @return {*}
   * @throws {Error} If the path is invalid.
   */
  getPropertyWithPath(obj, objPath, pathDelimiter = '/') {
    const parts = objPath.split(pathDelimiter);
    const first = parts.shift();
    let currentElement = obj[first];
    if (typeof currentElement === 'undefined') {
      throw new Error(`There's nothing on '${objPath}'`);
    } else if (parts.length) {
      let currentPath = first;
      parts.forEach((currentPart) => {
        currentPath += `/${currentPart}`;
        currentElement = currentElement[currentPart];
        if (typeof currentElement === 'undefined') {
          throw new Error(`There's nothing on '${currentPath}'`);
        }
      });
    }

    return currentElement;
  }
  ensureArray(obj) {
    return Array.isArray(obj) ? obj : [obj];
  }
}

export { AppUtils };
